import React from 'react';
import styled from 'styled-components';

import { Grid, GridItem, Container, AnimateIn, TitleSet, media } from '../ui-components';
import LeaderCard from './leader-card';
import Icon from '../components/icon';

import renderRichText from '../utils/render-rich-text';

import Person from '../models/Person/Person';

/**
 * Renders the experts section
 *
 * @function renderExpertSection
 * 
 * @param {object} props
 * 
 * @prop {string} expertTitle
 * @prop {string} expertsContent
 * @prop {string} expertsLabel
 * @prop {array} experts
 * @prop {string} pageType
 * @prop {boolean} renderIcon
 * 
 * @returns {JSX}
 */
const ExpertsSection = props => {
  const { expertsTitle, expertsContent, expertsLabel, experts, pageType, renderIcon = false, limit = true } = props;

  let refinedExperts = [];
  experts.forEach(expert => {
    if (!refinedExperts.includes(expert)) {
      refinedExperts.push(new Person(expert));
    }
  });

  let refinedExpertsContent =
    expertsContent && typeof expertsContent === 'object' ? renderRichText(expertsContent) : <p>{expertsContent}</p>;

  if (refinedExperts?.length >= 4 && limit) {
    for (let i = refinedExperts.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [refinedExperts[i], refinedExperts[j]] = [refinedExperts[j], refinedExperts[i]];
    }
    refinedExperts = refinedExperts.slice(0, 4);
  }

  if (refinedExperts.length > 0 && expertsContent && expertsTitle) {
    let expertCards = refinedExperts.map(expert => (
      <GridItem key={expert.slug} col={3} colxl={4} collg={6} colsm={12}>
        <LeaderCard slug={expert.slug} leader={expert} />
      </GridItem>
    ));

    return (
      <ExpertsSectionWrapper id="experts">
        <AnimateIn onScroll>
          <Container id="experts" sectionContainer>
            {renderIcon && <Icon horizontal={'right'} vertical={'top'} pageType={pageType} />}
            <TitleSet
              label={expertsLabel || 'Our Experts'}
              title={expertsTitle}
              bodyText={refinedExpertsContent}
            />
            <ExpertsGrid refinedExperts={refinedExperts} gridGap={24} justifyContent={'left'}>
              {expertCards}
            </ExpertsGrid>
          </Container>
        </AnimateIn>
      </ExpertsSectionWrapper>
    );
  }
};

const ExpertsGrid = styled(props => <Grid {...props} />)`
  #styled-grid-container {
    justify-content: ${({ refinedExperts }) => refinedExperts.length < 4 ? 'center' : 'normal'};

    @media screen and (max-width: ${media.mediumTop}) {
      justify-content: normal;
    }
  }
`;

const ExpertsSectionWrapper = styled.div`
  /* This div is needed to clip the overflow of the icons if rendered */
  overflow: clip visible;
`;

export default ExpertsSection;
